import { isProblemStatus } from '@/services/api';

/**
 * Whether a failed contact submission was the endpoint rejecting the address — a 400, reported on
 * the e-mail field — rather than a transport failure that belongs to the whole form.
 */
export function isRejectedAddress(error: unknown): boolean {
  return isProblemStatus(error, 400);
}
